//   export const createJob = async(companyId: string, jobData: Partial<Job>): Promise<Job> {
//     const response = await this.api.post<Job>(`/companies/${companyId}/jobs`, jobData);
//     return response.data;

import api, { apiService } from "../../../../services/api";

export const createJob = async (payload: any, isDraft = false) => {
  const url = isDraft ? `/jobs/?is_draft=true` : `/jobs/`;
  return await apiService.post(url, payload);
};
export const getJobsList = async (params: {
  status?: string;
  visibility?: string;
  department?: string;
  search_query?: string;
  // title?: string;
  // location?: string;
  hiring_manager_id?: string;
  recruiter_id?: string;
  limit?: number;
  offset?: number;
}) => {
  const queryParams = new URLSearchParams();
  if (params.status) queryParams.append("status", params.status);
  if (params.visibility) queryParams.append("visibility", params.visibility);
  if (params.department) queryParams.append("department", params.department);
  if (params.search_query)
    queryParams.append("search_query", params.search_query);
  // if (params.location) queryParams.append("location", params.location);
  if (params.hiring_manager_id)
    queryParams.append("hiring_manager_id", params.hiring_manager_id);
  if (params.recruiter_id)
    queryParams.append("recruiter_id", params.recruiter_id);
  if (params.limit !== undefined)
    queryParams.append("limit", params.limit.toString());
  if (params.offset !== undefined)
    queryParams.append("offset", params.offset.toString());

  const queryString = queryParams.toString();
  const url = `/jobs/${queryString ? `?${queryString}` : ""}`;
  return await apiService.get(url);
};
export const getJobsDetails = async (id: any) => {
  return await apiService.get(`/jobs/${id}`);
};
export const submitApprovalData = async (jobId: any, payload: any) => {
  return await apiService.post(`/jobs/${jobId}/submit`, payload);
};
export const pendingApprovaliData = async (params: {
  skip?: number;
  limit?: number;
} = {}) => {
  const queryParams = new URLSearchParams();
  if (params.skip !== undefined)
    queryParams.append("skip", params.skip.toString());
  if (params.limit !== undefined)
    queryParams.append("limit", params.limit.toString());

  const queryString = queryParams.toString();
  const url = `/jobs/pending-approvals/me${queryString ? `?${queryString}` : ""}`;
  return await apiService.get(url);
};

export const deleteJobs = async (jobId: any) => {
  return await apiService.delete(`/jobs/${jobId}`);
};
export const updateJobData = async (jobId: any, payload: any) => {
  return await apiService.put(`/jobs/${jobId}`, payload);
};
// export const getJobApprovals = async (jobId: any,payload: any) => {
// return await apiService.post(`/jobs/${jobId}/approve`, payload);
// }
export const getJobApprovals = async (
  jobId: string,
  payload: { action: "approve" | "reject"; comments?: string },
) => {
  return apiService.post(`/jobs/${jobId}/approve`, payload);
};
export const getApplicationStatsByStatus = async (jobId: string) => {
  return apiService.get(`/applications/stats/by-status?job_id=${jobId}`);
};
//  export const getJobApplicationDetails = async (jobId: string) => {
//   return apiService.get(`applications/?job_id=${jobId}&sort_by=applied_at&include_profile=false&limit=20&offset=0`);

//  }
export const getJobApplicationDetails = async (params: {
  sort_by?: "applied_at";
  include_profile?: boolean;
  jobId?: string;
  limit?: number;
  offset?: number;
  search?: string;
  status?: string;
}) => {
  const queryParams = new URLSearchParams();

  if (params.jobId) queryParams.append("job_id", params.jobId);

  if (params.sort_by) queryParams.append("sort_by", params.sort_by);

  if (params.include_profile !== undefined)
    queryParams.append("include_profile", String(params.include_profile));

  if (params.limit !== undefined)
    queryParams.append("limit", params.limit.toString());

  if (params.offset !== undefined)
    queryParams.append("offset", params.offset.toString());

  if (params.search) queryParams.append("search", params.search);

  if (params.status && params.status !== "all")
    queryParams.append("status", params.status);


  const url = `applications/?${queryParams.toString()}`;

  console.log("API URL:", url);

  return await apiService.get(url);
};
export const getJobApplicationViewDetails = async (applicationId: string) => {
  return apiService.get(`applications/${applicationId}`);
};
export const viewContactDetails = async (
  candidateId: string,
  payload?: any,
) => {
  return apiService.post(`candidates/${candidateId}/view-contact`, payload);
};
export const changeApplicationStatus = async (
  applicationId: string,
  payload: { status: string },
) => {
  return apiService.patch(`applications/${applicationId}/status`, payload);
};
export const sendMessageToApplication = (
  jobSeekerId: string,
  payload: {
    subject: string;
    message: string;
    access_type: string;
    application_id?: string;
    job_id?: string;
  },
) => {
  return apiService.post(`/candidates/${jobSeekerId}/message`, payload);
};
export const pauseJob = async (jobId: string) => {
  return apiService.post(`/jobs/${jobId}/pause`);
}
export const resumeJob = async (jobId: string) => {
  return apiService.post(`/jobs/${jobId}/resume`);
}
export const closeJob = async (jobId: string) => {
  return apiService.post(`/jobs/${jobId}/close`);
}
//http://18.188.73.145:8000/api/v1/applications/e770af06-d1bd-4a0e-8bde-2fb67ac11124/status
//http://18.188.73.145:8000/api/v1/candidates/9a3764c8-6ff8-486d-be32-6beae5c393d3/view-contact
